import { useState } from 'react'

import { useBillingSearchApi, useBillingSearchCondition } from '@/common/api/modules/billing'
import { useFirstLoading } from '@/common/api/search'

import Tab from '@/components/view/atoms/tab/Tab'
import TabList from '@/components/view/atoms/tab/TabList'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import BillingListTable from '@/components/container/modules/admin/billing/table/BillingListTable'
import BillingSearchConditionField from '@/components/container/modules/admin/billing/table/BillingSearchConditionField'
import ServiceUsageTab from '@/components/container/page/admin/billing/ServiceUsageTab'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

type BillingTab = 'records' | 'usage'

const BillingRecordsTab = () => {
  const [condition, setCondition, onUpdatePage] = useBillingSearchCondition()
  const { data, isLoading } = useBillingSearchApi(condition)
  const isFirstLoading = useFirstLoading(isLoading)

  if (isFirstLoading) {
    return <PageListLoading />
  }

  return (
    <Area tableWrap noBorder>
      <BillingSearchConditionField condition={condition} setCondition={setCondition} />
      {isLoading ? (
        <PageListSearching />
      ) : data?.total ? (
        <BillingListTable
          records={data.items}
          condition={condition}
          setCondition={setCondition}
          onUpdatePage={onUpdatePage}
          total={data.total}
        />
      ) : (
        <NoResultGuidance searched name='請求データ' />
      )}
    </Area>
  )
}

const BillingListPage = () => {
  const [tab, setTab] = useState<BillingTab>('usage')

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='請求管理'
        description='サイトごとの月別請求とサービス利用状況を管理します。'
      />
      <Content>
        <TabList border>
          <Tab selected={tab === 'usage'} onClick={() => setTab('usage')}>
            サービス利用状況
          </Tab>
          <Tab selected={tab === 'records'} onClick={() => setTab('records')}>
            請求一覧
          </Tab>
        </TabList>
        {tab === 'usage' ? <ServiceUsageTab /> : <BillingRecordsTab />}
      </Content>
    </Main>
  )
}

export default BillingListPage
